module.exports = __webpack_public_path__ + "static/media/pic-ht3.755f3c09.jpg";